module.exports = __webpack_public_path__ + "img/weibo_out.84049618.png";